import { render, staticRenderFns } from "./FcmbLogin.vue?vue&type=template&id=6df23d60"
import script from "./FcmbLogin.vue?vue&type=script&lang=js"
export * from "./FcmbLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports